<div
  class="tick"
  [ngClass]="{
    tick_active: active,
    tick_hover: hover
  }"
>
  <div class="tick__icon"></div>
</div>
